export enum experimentKeyEnum {
  WIX_WEBSITES_PDP = 'vxw_pdp_hero_layout',
  WIX_WEBSITES_PDP_PERFORMANCE_ANALYSIS = 'vxw_websitespdp_performance_analysis',
}

export enum variationKeyEnum {
  WIX_WEBSITES_PDP_CONTROL_VARIATION = 'control',
  WIX_WEBSITES_PDP_TEST_VARIATION = 'test',
}

export const experimentLocales = ['en-gb', 'en-ca', 'fr-ca', 'en-nz', 'en-au'];
